module.exports = __webpack_public_path__ + "img/msoffice.6f51b10f.png";